module.exports = __webpack_public_path__ + "static/media/display-3@768.f7f265e6.png";